import api from './api';

export interface ManualEntry {
  section: 'REVENUE' | 'TAX' | 'OPERATIONS';
  label: string;
  manualValue: number;
  itemCount?: number;
}

export interface ChannelRevenuePayload {
  channelId: number;
  grossAmount: number;
}

export interface EodConfirmRequest {
  summaryDate: string;
  manualEntries: ManualEntry[];
  closingNotes?: string;
  closingCash?: number;
  tipsTotal?: number;
  staffMealsCount?: number;
  staffMealsValue?: number;
  closeDaySession?: boolean;
  /** Backend upserts IncomeEntry per channel by externalRef "EOD:{v}:{d}:{cid}". */
  channelRevenues?: ChannelRevenuePayload[];
}

export interface EodSummaryLineResponse {
  section: string;
  label: string;
  sourceType: 'AUTO' | 'MANUAL' | 'OVERRIDE';
  autoValue?: number;
  manualValue?: number;
  finalValue?: number;
  overrideReason?: string;
  itemCount?: number;
  displayOrder?: number;
}

export interface EodSummaryResponse {
  id: number;
  summaryDate: string;
  status: 'DRAFT' | 'CONFIRMED';
  grossRevenue?: number;
  netRevenue?: number;
  totalTax?: number;
  totalExpenses?: number;
  totalDiscounts?: number;
  totalRefunds?: number;
  covers?: number;
  closingNotes?: string;
  confirmedBy?: string;
  confirmedAt?: string;
  isStale?: boolean;
  staleReason?: string;
  staleSince?: string;
  lines: EodSummaryLineResponse[];
}

export interface ChannelRevenueBrief {
  channelId: number;
  channelName: string;
  grossAmount: number;
}

export interface EodSummaryBrief {
  date: string;
  status: string;
  grossRevenue?: number;
  netRevenue?: number;
  totalExpenses?: number;
  covers?: number;
  cashVariance?: number;
  tipsTotal?: number;
  confirmedAt?: string;
  channelRevenues?: ChannelRevenueBrief[];
}

export interface EodHistoryAggregates {
  totalRevenue?: number;
  totalExpenses?: number;
  avgCovers?: number;
  avgRevenue?: number;
  totalDays?: number;
}

export interface EodHistoryResponse {
  summaries: EodSummaryBrief[];
  aggregates: EodHistoryAggregates;
}

export const eodApi = {
  generateSummary: (date: string) =>
    api.get<EodSummaryResponse>(`/api/vendor/finance/eod/generate?date=${date}`),

  getSummary: (date: string) =>
    api.get<EodSummaryResponse>(`/api/vendor/finance/eod/${date}`),

  confirmDay: (data: EodConfirmRequest) =>
    api.post<EodSummaryResponse>('/api/vendor/finance/eod/confirm', data),

  getHistory: (dateFrom: string, dateTo: string) =>
    api.get<EodHistoryResponse>('/api/vendor/finance/eod/history', {
      params: { dateFrom, dateTo },
    }),
};
